import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Btn, H4, P } from "../AbstractElements";
import { ForgotPassword, Password, RememberPassword } from "../Constant";

import { useNavigate } from "react-router-dom";
import man from "../assets/images/dashboard/profile.png";

import CustomizerContext from "../_helper/Customizer";
import OtherWay from "./OtherWay";
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import EgoalIcon from '../assets/images/logo/egoallogo.png';
import { Image } from '../AbstractElements';
import config from '../config';
import configDB from '../Config/ThemeConfig';
import CryptoJS from 'crypto-js';
import persistSession from './persistSession';
import MicrosoftSignInButton from './MicrosoftSignInButton';

const Signin = ({ selected }) => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [sentEmail, setSentEmail] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState(false);
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(localStorage.getItem("loginName"));
  const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [resetToken, setResetToken] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [microsoftEnabled, setMicrosoftEnabled] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus(); // Set focus when the component mounts
  }, []);

  useEffect(() => {
    localStorage.setItem("profileURL", man);
    localStorage.setItem("Name", '');
  }, [value, name]);

  // Ask the API whether Microsoft sign-in is available. Any failure leaves the
  // page exactly as it was, so this can never break password login.
  useEffect(() => {
    axios.get(`${config.hostname}/auth/methods`)
      .then((response) => {
        setMicrosoftEnabled(response.data && response.data.microsoft === true);
      })
      .catch(() => {
        setMicrosoftEnabled(false);
      });
  }, []);

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    const savedPassword = localStorage.getItem("rememberedPassword");

    if (savedUsername && savedPassword) {
      setUserName(savedUsername);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);


  const loginAuth = async (e) => {
    e.preventDefault();
    const encryptedPassword = CryptoJS.AES.encrypt(password, 'S7h^k9Lz*R!8rL1uNb#X@zPQ5uT3gBsH').toString();
    axios.post(`${config.hostname}/auth/login`, { username, password: encryptedPassword })
      // axios.post(`${config.hostname}/auth/login`, { username, password })
      .then(response => {

        // 👉 Remember Me logic
        if (rememberMe) {
          localStorage.setItem("rememberedUsername", username);
          localStorage.setItem("rememberedPassword", password);
        } else {
          localStorage.removeItem("rememberedUsername");
          localStorage.removeItem("rememberedPassword");
        }

        persistSession(response.data, history, layoutURL);
        setName(response.data.name);
        //toast.success("Successfully logged in!..");
      })
      .catch((error) => {
        console.log(error);
        toast.error('Error');
      });

  };

  const handleEmailClick = async (e) => {
    e.preventDefault();
    axios.post(`${config.hostname}/users/sendotp`, { email })
      .then((response) => {
        if (response.data === 'Email not found') {
          toast.error(response.data)
        }
        setSentEmail(true)
        setVerifyOtp(false)
      })
      .catch((error) => {
        console.log(error);
        toast.error('Error');
      });

  }

  // const handleVerifyOTP = async (e) => {
  //   e.preventDefault();
  //   axios.post(`${config.hostname}/users/verifyotp`, { username: email, otp })
  //     .then(() => {

  //       setVerifyOtp(true)
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       toast.error('Error');
  //     });

  // }

  const handleVerifyOTP = async (e) => {

    e.preventDefault();

    try {

      const response = await axios.post(
        `${config.hostname}/users/verifyotp`,
        {
          username: email,
          otp
        }
      );

      if (response.data.resetToken) {

        setResetToken(response.data.resetToken);
        setVerifyOtp(true);

        toast.success("OTP verified successfully");

      } else {

        toast.error("OTP verification failed");

      }

    } catch (error) {

      toast.error("Invalid OTP");

    }

  };

  // const handleResetPassword = async (e) => {
  //   e.preventDefault();
  //   axios.post(`${config.hostname}/users/resetpassword`, { username: email, newPassword })
  //     .then(() => {
  //       toast.success('Password reseted successfully')
  //       setSentEmail(false);
  //       setVerifyOtp(false);
  //       setOtp('');
  //       setEmail('')
  //       setNewPassword('')
  //       toggleModal();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       toast.error('Error');
  //     });

  // }

  const handleResetPassword = async (e) => {

    e.preventDefault();

    try {

      await axios.post(
        `${config.hostname}/users/resetpassword`,
        {
          username: email,
          newPassword,
          resetToken
        }
      );

      toast.success("Password reset successfully");

      setSentEmail(false);
      setVerifyOtp(false);


      setOtp('');
      setEmail('');
      setNewPassword('');
      setResetToken('');

      toggleModal();

    } catch (error) {

      toast.error("Password reset failed");

    }

  };


  return (
    <Fragment>
      <style>{`
        .v3-banner {
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin-bottom: 22px;
          padding: 11px 14px;
          border-radius: 8px;
          background: linear-gradient(120deg, #7b2ff7 0%, #b23bd6 50%, #f107a3 100%);
          color: #fff !important;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.3;
          text-align: center;
          text-decoration: none !important;
          box-shadow: 0 4px 14px rgba(123, 47, 247, 0.35);
          animation: v3BannerGlow 2.6s ease-in-out infinite;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .v3-banner:hover {
          transform: translateY(-2px) scale(1.02);
          box-shadow: 0 8px 22px rgba(241, 7, 163, 0.45);
          animation-play-state: paused;
        }
        /* Shimmer sweep across the banner */
        .v3-banner::after {
          content: "";
          position: absolute;
          top: 0;
          left: -60%;
          width: 40%;
          height: 100%;
          background: linear-gradient(100deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0) 100%);
          transform: skewX(-20deg);
          animation: v3BannerShimmer 3.2s ease-in-out infinite;
        }
        .v3-banner-badge {
          flex-shrink: 0;
          padding: 2px 7px;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.22);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
        .v3-banner-text {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .v3-banner-title {
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.2px;
        }
        .v3-banner-subtitle {
          margin-top: 1px;
          font-size: 11px;
          font-weight: 500;
          opacity: 0.9;
        }
        .v3-banner-arrow {
          flex-shrink: 0;
          font-size: 15px;
          transition: transform 0.25s ease;
        }
        .v3-banner:hover .v3-banner-arrow {
          transform: translateX(4px);
        }
        @keyframes v3BannerGlow {
          0%, 100% { box-shadow: 0 4px 14px rgba(123, 47, 247, 0.35); }
          50%      { box-shadow: 0 4px 20px rgba(241, 7, 163, 0.6); }
        }
        @keyframes v3BannerShimmer {
          0%        { left: -60%; }
          60%, 100% { left: 130%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .v3-banner, .v3-banner::after { animation: none; }
        }
      `}</style>
      <Container fluid={true} className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form">
                  {/* <H4>{selected === "simpleLogin" ? "" : "Sign In With Simple Login"}</H4> */}
                  <a
                    href="http://appv3.egoalprime.com/"  //V3 
                    // href="https://aldar.egoalprime.com/v3.0/"  //Aldar
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Click here to launch EGoal V3"
                    className="v3-banner"
                  >
                    <span className="v3-banner-badge">NEW</span>
                    <span className="v3-banner-text">
                      <span className="v3-banner-title">Discover EGoal v3</span>
                      <span className="v3-banner-subtitle">Intelligent Insights, Smarter Decisions</span>
                    </span>
                    <span className="v3-banner-arrow">&#8594;</span>
                  </a>
                  <Image attrImage={{ className: 'img-fluid d-inline', src: `${EgoalIcon}`, alt: '' }} />
                  {/* <P>{"Enter your email & password to login"}</P> */}
                  <FormGroup>
                    <Label className="col-form-label">Username</Label>
                    <Input className="form-control" type="text" ref={inputRef} onChange={(e) => setUserName(e.target.value)} value={username} />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">Password</Label>
                    <div className="position-relative">
                      <Input className="form-control" type={togglePassword ? "text" : "password"}
                        onChange={(e) => setPassword(e.target.value)} value={password}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            if (password === 'egoal@1') {
                              toggleModal(); // reset password for first time login'
                              localStorage.setItem("showGuideTour", "1");
                            } else {
                              localStorage.setItem("showGuideTour", "0");
                              loginAuth(e); // Otherwise, proceed with loginAuth
                            }
                          }
                        }} />
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                  </FormGroup>
                  <div className="position-relative form-group mb-0">
                    <div className="checkbox">
                      <Input id="checkbox1" type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)} />
                      <Label className="text-muted" for="checkbox1">
                        {RememberPassword}
                      </Label>
                    </div>
                    <a className="link" style={{ cursor: 'pointer' }} onClick={toggleModal}>
                      {ForgotPassword}
                    </a>
                    <Btn attrBtn={{
                      color: "primary", className: "d-block w-100 mt-2", onClick: (e) => {
                        if (password === 'egoal@1') {
                          toggleModal(); // reset password for first time login'
                          localStorage.setItem("showGuideTour", "1");
                        } else {
                          localStorage.setItem("showGuideTour", "0");
                          loginAuth(e);
                        }
                      },
                    }}>Sign In</Btn>
                    {microsoftEnabled && <MicrosoftSignInButton />}
                  </div>
                  <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Reset Password</ModalHeader>
                    <ModalBody>
                      <FormGroup>
                        <Label className="mb-3" for="email">Enter your email address and we'll send you an email with instructions to reset your password.</Label>
                        <Input className="mb-3" type="email" id="email" onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" />
                        <Btn attrBtn={{ color: "primary", onClick: (e) => handleEmailClick(e) }}> {sentEmail === true ? 'Resend OTP' : 'Send OTP'}</Btn>
                      </FormGroup>

                      {sentEmail === true && (
                        <Row>
                          <FormGroup>
                            <Label className="mb-3" for="email">Enter OTP</Label>
                            <Input className="mb-3" type="text" id="otp" onChange={(e) => setOtp(e.target.value)} value={otp} placeholder="Enter OTP" />
                            <Btn attrBtn={{ color: "primary", onClick: (e) => handleVerifyOTP(e), disabled: verifyOtp }}>Verify OTP</Btn>
                          </FormGroup>
                        </Row>
                      )}
                      {verifyOtp === true && (
                        <Row>
                          <FormGroup>
                            <Label className="mb-3" for="newpass">Enter New Password</Label>
                            <Input className="mb-3" type="password" id="newPassword" onChange={(e) => setNewPassword(e.target.value)} value={newPassword} placeholder="Enter New Password" />
                            <Btn attrBtn={{ color: "primary", onClick: (e) => handleResetPassword(e) }}>Reset Password</Btn>
                          </FormGroup>
                        </Row>
                      )}
                    </ModalBody>
                  </Modal>
                  {/* <OtherWay /> */}
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
